import { getBytes, ref } from "firebase/storage";
import { storage } from "../config/firebase";

function blobToDataUrl(blob) {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(typeof reader.result === "string" ? reader.result : "");
    };
    reader.onerror = () => resolve("");
    reader.readAsDataURL(blob);
  });
}

/**
 * Extrait le chemin objet (ex. property-media/id/building/file.png) depuis une URL de téléchargement Storage.
 * Firebase v12 n’expose plus refFromURL ; ref(storage, path) + getBytes utilise le SDK (souvent OK même si fetch() est bloqué par CORS).
 */
function storageObjectPathFromDownloadUrl(url) {
  try {
    const u = new URL(url);
    if (
      !u.hostname.includes("firebasestorage.googleapis.com") &&
      !u.hostname.includes("firebasestorage.app")
    ) {
      return null;
    }
    const marker = "/o/";
    const idx = u.pathname.indexOf(marker);
    if (idx === -1) return null;
    const encoded = u.pathname.slice(idx + marker.length);
    return decodeURIComponent(encoded);
  } catch {
    return null;
  }
}

function isFirebaseStorageDownloadUrl(url) {
  return (
    typeof url === "string" &&
    (url.includes("firebasestorage.googleapis.com") ||
      url.includes("firebasestorage.app"))
  );
}

/**
 * Image en data URL pour @react-pdf/renderer.
 *
 * Si le navigateur bloque fetch() (CORS sur le bucket), configurez le bucket :
 *   gsutil cors set storage-cors.json gs://VOTRE_STORAGE_BUCKET
 * (fichier storage-cors.json à la racine du repo ; bucket = VITE_FIREBASE_STORAGE_BUCKET.)
 *
 * @param {string} url
 * @returns {Promise<string>} data URL ou chaîne vide
 */
export async function resolveImageForPdf(url) {
  if (!url || typeof url !== "string") return "";
  const trimmed = url.trim();
  if (!trimmed) return "";
  if (trimmed.startsWith("data:")) return trimmed;

  if (isFirebaseStorageDownloadUrl(trimmed)) {
    const objectPath = storageObjectPathFromDownloadUrl(trimmed);
    if (objectPath) {
      try {
        const storageRef = ref(storage, objectPath);
        const bytes = await getBytes(storageRef, 10 * 1024 * 1024);
        const blob = new Blob([bytes]);
        if (!blob.size) return "";
        const dataUrl = await blobToDataUrl(blob);
        if (dataUrl) return dataUrl;
      } catch {
        /* secours fetch ci-dessous */
      }
    }
  }

  try {
    const res = await fetch(trimmed, { mode: "cors", credentials: "omit" });
    if (!res.ok) return "";
    const blob = await res.blob();
    if (!blob || blob.size === 0) return "";
    return await blobToDataUrl(blob);
  } catch {
    return "";
  }
}
